var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-steps-indicator"},[_c('div',{staticClass:"d-flex pb-3 pt-4 align-items-center"},_vm._l((_vm.steps),function(ref){
var position = ref.position;
var title = ref.title;
return _c('div',{key:position,staticClass:"step flex-fill",class:{ active: position <= _vm.activeStep.position, last: _vm.activeStep.position === position }},[_c('div',{staticClass:"step-circle d-inline-block"}),_c('div',{staticClass:"step-title small"},[_vm._v(_vm._s(title))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }